<div class="welcome-tour" role="presentation">
  <div class="welcome-tour__scrim" (click)="hold($event)"></div>

  @if (targetRect(); as rect) {
    <div
      class="welcome-tour__hole"
      [style.top.px]="rect.top - 6"
      [style.left.px]="rect.left - 6"
      [style.width.px]="rect.width + 12"
      [style.height.px]="rect.height + 12"
      (click)="advanceFromTarget($event)"
    ></div>
  }

  <section
    #popover
    class="welcome-tour__card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="welcome-tour-title"
    [style]="cardStyle()"
    (click)="hold($event)"
  >
    <h2 id="welcome-tour-title" class="welcome-tour__title">{{ current().title }}</h2>
    <p class="welcome-tour__text">{{ current().text }}</p>
    <div class="welcome-tour__actions">
      <button type="button" class="welcome-tour__text-button" (click)="skip()">Omitir</button>
      <span class="welcome-tour__actions-end">
        @if (showBack()) {
          <button type="button" class="welcome-tour__ghost" (click)="back()">Atrás</button>
        }
        <button type="button" class="welcome-tour__primary" data-tour-next (click)="next()">
          {{ isLastStep() ? 'Entrar' : 'Siguiente' }}
        </button>
      </span>
    </div>
  </section>
</div>
